<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M3 13.333l2.17-8.098A1.667 1.667 0 016.778 4H25.22c.754 0 1.415.507 1.61 1.235L29 13.333a4 4 0 01-1 2.646v10.354c0 .92-.746 1.667-1.667 1.667H21v-6.667h-4V28H5.667C4.747 28 4 27.254 4 26.333V15.98a4 4 0 01-1-2.646zM24.965 6H7.035L5 13.333a2 2 0 104 0h2a2 2 0 104 0h2a2 2 0 104 0h2a2 2 0 104 0L24.965 6zM26 17.206V26h-3v-5c0-.92-.746-1.667-1.667-1.667h-4.666c-.92 0-1.667.747-1.667 1.667v5H6v-8.794a3.998 3.998 0 004-1.227 3.995 3.995 0 003 1.354 4 4 0 003-1.354 4 4 0 006 0 3.995 3.995 0 003 1.354c.338 0 .674-.042 1-.127z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'placesStoreOutline'
}
</script>
